import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface IPrimaryLinkProps {
  inlineText?: boolean
  disabled?: boolean
  theme?: ITheme
}
export const PrimaryLink = styled('a')<IPrimaryLinkProps>`
  color: ${(props) =>
    props.inlineText ? 'inherit' : props.theme.colors.textDarkblack};
  font-weight: ${(props) =>
    props.inlineText ? 'inherit' : props.theme.font.weight.normal};
  color: ${(props) => props.disabled && '#cccccc'};
  text-decoration: underline;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    color: ${(props) => props.disabled ? '#cccccc': props.theme.colors.navColor};
  }
`
